import React from 'react';
import { Typography, List, ListItem, Grid, Row, Col } from '@sm/wds-react';
import { defineMessages, T } from '@sm/intl';
import { getSolutionsByNeedItems } from './navSubmenuListItems';

const COPY = defineMessages({
  BY_NEED: {
    id: 'NavSubmenuByNeed.byNeed',
    defaultMessage: 'By Need',
    description: '[Type: Label][Vis.: med] - By need label for Nav Submenu'
  }
});

const renderItems = item => {
  const { title = '', url = '' } = item;
  return (
    <ListItem
      key={title}
      className="sm-nav-submenu__by-need-container"
      isNavigable
      navigationTarget={url}
    >
      <Typography
        variant="body"
        color="link"
        className="sm-nav-submenu__by-need"
      >
        {title}
      </Typography>
    </ListItem>
  );
};

export const NavSubmenuByNeed = () => {
  const itemsData = getSolutionsByNeedItems();
  const submenuColumns = itemsData.map(column => {
    const columnData = column.map(items => renderItems(items));
    return (
      <Col key={column[0].title} className="sm-nav-submenu__col">
        <List>{columnData}</List>
      </Col>
    );
  });

  return (
    <Grid>
      <Typography
        variant="cardTitle"
        color="dark"
        className="sm-nav-submenu__by-need-title"
      >
        <T desc={COPY.BY_NEED} />
      </Typography>
      <Row className="submenu-lo--row">{submenuColumns}</Row>
    </Grid>
  );
};

export default NavSubmenuByNeed;
